/*
 * Trinom Digital Pvt Ltd ("COMPANY") CONFIDENTIAL                             *
 * Copyright (c) 2023 Trinom Digital Pvt Ltd, All rights reserved              *
 *                                                                             *
 * NOTICE:  All information contained herein is, and remains the property      *
 * of COMPANY. The intellectual and technical concepts contained herein are    *
 * proprietary to COMPANY and may be covered by Indian and Foreign Patents,    *
 * patents in process, and are protected by trade secret or copyright law.     *
 * Dissemination of this information or reproduction of this material is       *
 * strictly forbidden unless prior written permission is obtained from         *
 * COMPANY. Access to the source code contained herein is hereby forbidden     *
 * to anyone except current COMPANY employees, managers or contractors who     *
 * have executed Confidentiality and Non-disclosure agreements explicitly      *
 * covering such access.                                                       *
 *                                                                             *
 * The copyright notice above does not evidence any actual or intended         *
 * publication or disclosure of this source code, which includes               *
 * information that is confidential and/or proprietary, and is a trade secret, *
 * of COMPANY. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC            *
 * PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE CODE        *
 * WITHOUT THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED,      *
 * AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE         *
 * RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES   *
 * NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS     *
 * CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,    *
 * IN WHOLE OR IN PART.                                                        *
 *                                                                             *
 * File: \src\utils\axios_utils.js                                             *
 * Project: Telemedicine-MyMedicine                                            *
 * Created Date: Thursday, November 16th 2023, 3:01:50 pm                      *
 * Author: Shyam Mohan <shyam@codestax.ai>                                     *
 * -----                                                                       *
 * Last Modified: June 12th 2025, 9:13:42 am                                   *
 * Modified By: Prakersh Arya                                                  *
 * -----                                                                       *
 * Any app that can be written in JavaScript,                                  *
 *     will eventually be written in JavaScript !!                             *
 * -----                                                                       *
 * HISTORY:                                                                    *
 * Date         By  Comments                                                   *
 * --------------------------------------------------------------------------- *
 */

import VueCookies from "vue-cookies";
import axios from 'axios';
import router from '@/router';
const base_axios_instance = axios.create({baseURL: process.env.VUE_APP_BACKEND_URL});
const base_axios_instance_hospital_customer = axios.create({baseURL: process.env.VUE_APP_HBA_CUSTOMER});
const axios_auth_instance_customer = axios.create({baseURL: process.env.VUE_APP_BACKEND_URL});
const axios_auth_instance_admin = axios.create({baseURL: process.env.VUE_APP_BACKEND_URL});
const axios_auth_instance_doctor = axios.create({baseURL: process.env.VUE_APP_BACKEND_URL});
const axios_auth_instance_epharmacy_customer = axios.create({baseURL: process.env.VUE_APP_EPHARMACY_BACKEND_URL});
const axios_auth_instance_nurseBooking = axios.create({baseURL: process.env.VUE_APP_NBA_CUSTOMER});
const axios_auth_instance_epharmacy_admin = axios.create({baseURL: process.env.VUE_APP_EPHARMACY_BACKEND_URL});
const axios_auth_instance_hba_customer = axios.create({baseURL: process.env.VUE_APP_HBA_CUSTOMER});
const axios_auth_instance_nba_admin = axios.create({baseURL: process.env.VUE_APP_NBA_ADMIN_BACKEND_URL})

axios_auth_instance_epharmacy_admin.interceptors.request.use((config) => {
    const token = VueCookies.get('token');
    config.headers['Access-Token'] = token;
    config.headers['Type-Of-User'] = 'ADMIN';
    return config;
});

base_axios_instance.interceptors.response.use(
    (response) => {
      // If the response status is in the 2xx range, consider it a success and return the response
      return response;
    },
    (error) => {
      // If the response status is outside the 2xx range, treat it as an error
      return Promise.reject(error);
    }
  );

axios_auth_instance_admin.interceptors.request.use((config) => {
    const token = VueCookies.get('token');
    config.headers['Access-Token'] = token;
    config.headers['Type-Of-User'] = 'ADMIN';
    return config;
});

axios_auth_instance_customer.interceptors.request.use((config) => {
    const token = VueCookies.get('customerToken');
    config.headers['Access-Token'] = token;
    config.headers['Type-Of-User'] = 'CUSTOMER';
    return config;
});

axios_auth_instance_doctor.interceptors.request.use((config) => {
    const token = VueCookies.get('doctorToken');
    config.headers['Access-Token'] = token;
    config.headers['Type-Of-User'] = 'DOCTOR';
    return config;
});

axios_auth_instance_epharmacy_customer.interceptors.request.use((config) => {
    const token = VueCookies.get('customerToken');
    config.headers['authorization'] = `bearer ${token}##myMed##`;
    return config;
});

axios_auth_instance_nurseBooking.interceptors.request.use((config) => {
    const token = VueCookies.get('customerToken');
    config.headers['authorization'] = `bearer ${token}##myMed##`;
    return config;
})

axios_auth_instance_hba_customer.interceptors.request.use((config) => {
    const token = VueCookies.get('customerToken');
    config.headers['authorization'] = `bearer ${token}##myMed##`;

    return config;
});

axios_auth_instance_nba_admin.interceptors.request.use((config) => {
    const token = VueCookies.get('customerToken');
    config.headers['authorization'] = `bearer ${token}##myMed##`;
    return config;
});

axios_auth_instance_hba_customer.interceptors.response.use((response) => (response), (error) => {
    if (error.response) {
        if (error.response.status === 401 || error.response.status === 403) {
            VueCookies.remove('token');
            // router.push({ name: 'Login' });
        } else {
            alert(error.response.data.message || 'SOMETHING WENT WRONG');
        }
    } else if (error.request) {
        // NETWORK ERROR
        alert('NETWORK ERROR');
    } else {
        alert('SOMETHING WENT WRONG');
    }
    // If the response status is outside the 2xx range, treat it as an error
    return Promise.reject({
        errorObj: error,
        errorMessage: error.message || 'Request Failed',
        responseStatus: error.response.status
    });    

});




export {
    base_axios_instance,
    axios_auth_instance_customer,
    axios_auth_instance_admin,
    axios_auth_instance_doctor,
    axios_auth_instance_epharmacy_admin,
    axios_auth_instance_epharmacy_customer,
    axios_auth_instance_nurseBooking,
    base_axios_instance_hospital_customer,
    axios_auth_instance_hba_customer,
    axios_auth_instance_nba_admin
};